import { useLocalizationExtension } from '../../../context/Localization/localization';
import { TextFieldValidationProps } from './TextFieldValidation.types';

/**
 * This function handles zipCode, postalCode, vin, and email validation for the useField formik validator.
 */
const TextFieldValidation = ({
    name,
    label,
    required,
    validationType,
}: TextFieldValidationProps) => {
    const { formatRequired, emailInvalid, zipCodeInvalid, postalCodeInvalid, vinInvalid, vinInvalidFullOrLast8 } = useLocalizationExtension();

    return async (value: string) => {
        if (typeof value !== 'string') {
            return undefined;
        }

        value = value.trim();
        const isBlank = value.length === 0;

        if (required && isBlank) {
            return formatRequired(label || name);
        }
        else if (!isBlank && validationType === 'email' && !(/^[^@]+@[^@.]+\.[^@]+$/).test(value)) {
            return emailInvalid;
        }
        else if (!isBlank && validationType === 'zipCode' && !(/^\d{5}(?:[- ]?\d{4})?$/).test(value)) {
            return zipCodeInvalid;
        }
        else if (!isBlank && validationType === 'postalCode' && !(/^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/).test(value)) {
            return postalCodeInvalid;
        }
        else if (!isBlank && validationType === 'vin' && !(/^[A-Z0-9]{17}$/i).test(value)) {
            return vinInvalid;
        }
        else if (!isBlank && validationType === 'vinFullOrLast8' && !(/^([A-Z0-9]{8}|[A-Z0-9]{17})$/i).test(value)) {
            return vinInvalidFullOrLast8;
        }

        return undefined;
    };
};

export default TextFieldValidation;